export default {
	'add-visit': 'إضافة زيارة',
	'edit-visit': 'تعديل زيارة',
	'visit-is-created': 'تم إضافة الزيارة',
	'visit-is-updated': 'تم تعديل الزيارة',
	'the-visit': 'الزيارة',
	'daily-report': 'التقرير اليومي',
	'report-type': {
		important: 'مهم',
		complaint: 'شكوى',
		'normal-note': 'ملاحظة عادية',
	},
	'daily-report-is-updated': 'تم تحديث التقرير اليومي',
	'no-visits-to-show': 'لا توجد زيارات للعرض',
	'visit-details': 'تفاصيل الزيارة',
	total: 'الإجمالي',

	'balance-update': 'تعديل الرصيد',
	'balance-update-error': 'حدث خطأ أثناء تحديث الرصيد، يرجى نقر "تحديث" من أجل إعادة محاولة التحديث',

	'tab-scientific': 'علمي',
	'tab-commercial': 'تجاري',
	'tab-marketing': 'تسويقي',
	'create-order': 'إنشاء طلبية',
	'order-items': 'مواد الطلبية',
	order: 'الطلبية',
	'order-id': 'رقم الطلبية',
	'order-details': 'تفاصيل الطلبية',
	'no-order-items': 'لا توجد مواد في الطلبية',
	'order-delivery-date-without-items': 'يرجى إضافة مواد للطلبية أو تفريغ تاريخ التسليم للمتابعة.',
	'add-plan-materials': 'إضافة مواد الخطة',
	'remove-plan-materials': 'إزالة مواد الخطة',
}